import { FormlyFieldConfig } from "@ngx-formly/core";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { Injector } from "@angular/core";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsSimpleQueryNode } from "../../MedicinalProductsSimpleQueryNode";
import { QueryConditionsNode } from "../../../QueryConditionsNode";
import { ResultList } from "../../../ListEntity/ResultList";
import { QueryFieldsNode } from "../../../QueryFieldsNode";

export class SubstanceNamesQueryNode extends MedicinalProductsSimpleQueryNode {
    constructor(injector: Injector, entity: EntityEnum) {
    
    let queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).substancesNamesFields;
    let queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).substancesNamesConditions;
    
    let labelTemplate: string = 'Substance Names';
    switch (entity) {
        case 'approvedSubstanceNames':
            labelTemplate = 'Approved Substance Names';
            queryFields = new FieldDefinitionFields(injector).substancesNamesByTypesFields;
            queryConditions.forEach((condition: any) => condition['key']=='substancename' ? condition.props.lookup['parameters'] = [["type", 2]] : '');
            break;
        case "developmentSubstanceNames":
            labelTemplate = 'Development Substance Names';
            queryFields = new FieldDefinitionFields(injector).substancesNamesByTypesFields;
            queryConditions.forEach((condition: any) => condition['key']=='substancename' ? condition.props.lookup['parameters'] = [["type", 1]] : '');
    }
       super(injector, [], labelTemplate, entity)
       this.children!.push(new QueryFieldsNode(injector, queryFields, []));
       this.children!.push(new QueryConditionsNode(injector, queryConditions));
       this.children!.push(new ResultList(injector));
    }
}